import { useCallback, useMemo } from 'react';

import {
  exploreFormDescriptionState,
  exploreFormExampleCompaniesState,
  exploreFormLocationsState,
} from '../explore.state';
import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';

export const useExploreForm = () => {
  const [locations, setLocations] = useAtom(exploreFormLocationsState);
  const resetLocations = useResetAtom(exploreFormLocationsState);
  const [exampleCompanies, setExampleCompanies] = useAtom(
    exploreFormExampleCompaniesState,
  );
  const resetExampleCompanies = useResetAtom(exploreFormExampleCompaniesState);
  const [description, setDescription] = useAtom(exploreFormDescriptionState);
  const isValid = !!description.length;

  const isDirty = useMemo(() => {
    return !!locations.length || !!exampleCompanies.length || !!description;
  }, [locations, exampleCompanies, description]);

  const resetForm = useCallback(() => {
    resetLocations();
    setDescription('');
    resetExampleCompanies();
  }, [resetExampleCompanies, resetLocations, setDescription]);

  return {
    locations,
    setLocations,
    description,
    setDescription,
    exampleCompanies,
    setExampleCompanies,
    isDirty,
    isValid,
    resetForm,
  };
};
